import styled, { css } from 'styled-components';
import DropdownMenu from './DropdownMenu.js';

/* eslint-disable max-len */
const StyledApplicationSwitcher = styled.div `
    .helix-unified-nav__navigation-item {
        :hover,
        &.active {
            background-color: transparent;
        }
    }
    .helix-unified-nav__navigation-item {
        svg {
            margin-left: 8px;
            ${({ $isDark }) => $isDark &&
    css `
                    path {
                        fill: currentColor !important;
                    }
                `}
        }
    }

    .helix-unified-nav__application-switcher-product-name {
        font-weight: 600;
        -webkit-font-smoothing: antialiased;
        color: ${({ $isDark }) => ($isDark ? 'inherit' : '#111827')};
        white-space: nowrap;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans',
            'Helvetica Neue', sans-serif;
    }

    button:not(.helix-app-switcher__item-badge-dropdown) {
        &:not(.helix-unified-nav__navigation-item):not(.helix-unified-nav__app-switcher-panel-section-item) {
            display: inline-flex;
            flex: 0 0 auto;
            align-items: center;
            background-color: transparent;
            border: none;
            padding: 8px 0;
            color: inherit;
        }
    }

    .helix-unified-nav__app-switcher-panel-section-item {
        display: inline-flex;
        flex: 0 0 auto;
        align-items: center;
        background-color: transparent;
        border: none;
        color: inherit;
        a {
            color: inherit;

            &:hover {
                text-decoration: none !important;
            }
        }
        &:hover {
            text-decoration: none !important;
        }
    }

    .helix-unified-nav__app-switcher-panel {
        padding: 12px;
        .helix-unified-nav__app-switcher-panel-section {
            margin-bottom: 12px !important;
            &:last-child {
                margin-bottom: 0;
            }
        }
        .helix-unified-nav__app-switcher-panel-section-name {
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            letter-spacing: 0.04em;
            padding: 8px;
            text-transform: uppercase;
        }
        .helix-unified-nav__app-switcher-panel-section-item {
            padding: 8px;
            display: flex;
            width: 100%;
            justify-content: flex-start;
            align-items: flex-start;
            text-align: left;
            border-radius: 6px;
            &:hover,
            &:focus {
                background-color: #f3f4f6;
            }
            &:focus {
                outline: solid 2px #60a5fa;
            }
            &.selected-item {
                outline-width: 0;
                background-color: #f3f4f6;
            }
            .helix-unified-nav__app-switcher-panel-section-item-content-wrapper {
                flex: 1 1;
                padding-right: 8px;
                display: flex;
                .helix-unified-nav__app-switcher-panel-item-icon {
                    margin-right: 8px;
                }
                .helix-unified-nav__app-switcher-panel-item-content-container {
                    display: flex;
                    flex: 1 1;
                    @media screen and (max-width: 319px) {
                        flex-flow: column;
                    }
                    .helix-unified-nav__app-switcher-panel-item-content {
                        flex: 1 1;

                        .helix-unified-nav__app-switcher-panel-item-label {
                            font-weight: 600;
                            font-size: 14px;
                            line-height: 20px;
                        }
                        .helix-unified-nav__app-switcher-panel-item-description {
                            font-weight: 600;
                            font-size: 14px;
                            line-height: 20px;
                            font-weight: normal;
                            font-size: 12px;
                            line-height: 16px;
                            color: #4b5563;
                        }
                    }
                }
            }
            &.not-active {
                .helix-unified-nav__app-switcher-panel-item-content {
                    opacity: 0.6;
                }
            }

            .helix-unified-nav__app-switcher-panel-item-not-active {
                background-color: #111827;
                padding: 3px 6px;
                display: flex;
                align-items: center;
                font-size: 11px;
                border-radius: 20px;
                color: #f3f4f6;
                float: right;
                height: fit-content;
                @media screen and (max-width: 319px) {
                    width: fit-content;
                    margin-top: 4px;
                }
            }
        }
    }
`;
const StyledBarDropDownMenu = styled(DropdownMenu) `
    max-height: calc(100vh - 80px);
    overflow: auto;
    .helix-unified-nav__application-switcher-section {
        flex: 1 1;
        .label {
            font-weight: 600;
        }
    }
    .helix-unified-nav__application-switcher-section-list {
        display: flex;
        flex-direction: column;
    }

    .helix-unified-nav__application-switcher-sections-wrapper {
        display: flex;
    }

    .helix-unified-nav__application-switcher-section--launchpad {
        cursor: default !important;
        display: flex !important;
        justify-content: center;
        align-items: center;
        border-radius: 0 !important;
        flex: 1 1 100%;
        border-top: solid 1px #e5e7eb;
        padding-top: 6px;
        margin-top: 4px;
        font-size: 14px;
        .menu-item-content-wrapper {
            padding: 0 !important;
            a {
                padding: 8px !important;
            }
        }
        &:hover {
            a {
                background-color: transparent !important;
            }
        }

        a {
            display: flex;
            justify-content: center;
            align-items: center;
            color: inherit;
            padding: 8px !important;
            border-radius: 6px;
            &:hover {
                background-color: #f3f4f6 !important;
                text-decoration: none !important;
            }
        }

        &.highlighted {
            background-color: transparent !important;
            a {
                background-color: #f3f4f6;
            }
        }
        .helix-navbar__application-switcher-launchpad-item__label {
            font-weight: 600;
            margin-left: 8px;
        }
        .helix-navbar__application-switcher-launchpad-item__description {
            font-weight: 400;
            margin-left: 12px;
            color: #4b5563;
        }
    }

    @media screen and (max-width: 576px) {
        visibility: hidden;
    }
`;
const StyledAppItem = styled.li `
    display: grid;
    grid-template-columns: 16px 1fr;
    gap: 16px;
    .menu-item-content-wrapper {
        flex-flow: row;
        display: flex;
        align-items: flex-start !important;
        .helix-app-switcher__item-icon {
            margin-right: 8px;
            display: flex;
        }
        .menu-item-content {
            display: flex;
            flex-flow: column;
            flex: 1 1;
            .label {
                flex: 1 1;
            }
        }
        a {
            padding: 0 !important;
            width: 100%;
            display: flex;
        }
    }
    .not-active {
        background-color: #111827;
        padding: 3px 6px;
        display: flex;
        align-items: center;
        font-size: 11px;
        border-radius: 20px;
        color: #f3f4f6;
        float: right;
    }
`;
styled.div `
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    margin-bottom: 2px;
`;
styled.div `
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    width: 100%;
    a {
        color: inherit;
        padding: 8px 8px 8px 24px;
        width: 100%;
        border-radius: 6px;
        text-decoration: none;
        &:hover,
        &:focus {
            background-color: #f3f4f6;
        }
    }
`;
const StyledAppInstanceBadgeDropdownWrapper = styled.div `
    display: inline-block;
`;
const StyledAppInstanceBadgeDropdown = styled.button `
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 99px;
    background-color: #e5e7eb;
    font-size: 12px;
    font-weight: 400;
    color: #1f2937;
    padding: 2px 8px;
    margin-top: 4px;
    width: fit-content;
    white-space: nowrap;
    border: none;
    svg {
        margin-left: 8px;
    }
`;

export { StyledAppInstanceBadgeDropdown, StyledAppInstanceBadgeDropdownWrapper, StyledAppItem, StyledApplicationSwitcher, StyledBarDropDownMenu };
//# sourceMappingURL=ApplicationSwitcher.styles.js.map
